// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#partner-landing-screen #olist .partner-landing-header {
  background-color: #0c29d0;
}
#partner-landing-screen #olist .partner-landing-header .logo {
  width: 9rem;
}
@media (max-width: 768px) {
  #partner-landing-screen #olist .partner-landing-header {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
#partner-landing-screen #olist .olist-title {
  color: #0c29d0;
}
#partner-landing-screen #olist .olist-white-title {
  color: #d2f9ed;
}
#partner-landing-screen #olist .steps-content {
  margin-top: 1.25rem;
}
#partner-landing-screen #olist .light {
  color: black !important;
  background-color: var(--primary-light-color) !important;
}
#partner-landing-screen #olist .light .ant-layout-content {
  background-color: transparent !important;
}
#partner-landing-screen #olist .light h1,
#partner-landing-screen #olist .light h2,
#partner-landing-screen #olist .light h3 {
  color: black;
}
#partner-landing-screen #olist .soft {
  color: black !important;
  background-color: #e1eef1 !important;
}
#partner-landing-screen #olist .soft .ant-layout-content {
  background-color: transparent !important;
}
#partner-landing-screen #olist .soft h1,
#partner-landing-screen #olist .soft h2,
#partner-landing-screen #olist .soft h3 {
  color: black;
}
#partner-landing-screen #olist .dark {
  color: white !important;
  background-color: #0c29d0 !important;
}
#partner-landing-screen #olist .dark .ant-layout-content {
  background-color: transparent !important;
}
#partner-landing-screen #olist .dark h1,
#partner-landing-screen #olist .dark h2,
#partner-landing-screen #olist .dark h3 {
  color: white;
}
#partner-landing-screen #olist .ant-steps .ant-steps-item-active .ant-steps-icon {
  color: #ffffff !important;
}
#partner-landing-screen #olist .ant-steps .ant-steps-item-process .ant-steps-item-icon {
  background-color: #0c29d0;
  border-color: #0c29d0;
}
#partner-landing-screen #olist .ant-steps .ant-steps-item-finish .ant-steps-item-icon {
  background-color: #0c29d0;
  border-color: #0c29d0;
}
#partner-landing-screen #olist .ant-steps .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon {
  color: #ffffff !important;
}
#partner-landing-screen #olist .ant-steps .ant-steps-item::before {
  background-color: #0c29d0;
}
#partner-landing-screen #olist .ant-steps .ant-steps-item-title::hover {
  background-color: #0c29d0;
}
#partner-landing-screen #olist .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #0c29d0;
}
#partner-landing-screen #olist .gyramais-btn.gyramais-btn-olist {
  background-color: #0c29d0;
  color: white;
}
@media (max-width: 768px) {
  #partner-landing-screen .gyra-logo-partner {
    margin-bottom: 1rem;
  }
}
.codeAlreadyUsedModal .img-container {
  display: flex;
  justify-content: center;
}
.codeAlreadyUsedModal .confirm-modal-image {
  max-height: 10.813rem;
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
}
.codeAlreadyUsedModal button {
  margin-top: 1rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/screens/PartnerLandingScreen/styles.less"],"names":[],"mappings":"AAAA;EAGM,yBAAA;AADN;AAFA;EAMQ,WAAA;AADR;AAIM;EAAA;IACE,mBAAA;IACA,sBAAA;EADN;AACF;AAXA;EAgBO,cAAA;AAFP;AAdA;EAmBO,cAAA;AAFP;AAjBA;EAuBM,mBAAA;AAHN;AApBA;EA2BM,uBAAA;EACA,uDAAA;AAJN;AAxBA;EA8BQ,wCAAA;AAHR;AA3BA;;;EAiCQ,YAAA;AADR;AAhCA;EAsCM,uBAAA;EACA,oCAAA;AAHN;AApCA;EAyCQ,wCAAA;AAFR;AAvCA;;;EA4CQ,YAAA;AAAR;AA5CA;EAiDM,uBAAA;EACA,oCAAA;AAFN;AAhDA;EAoDQ,wCAAA;AADR;AAnDA;;;EAuDQ,YAAA;AACR;AAxDA;EA6DQ,yBAAA;AAFR;AA3DA;EAiEQ,yBAAA;EACA,qBAAA;AAHR;AA/DA;EAqEQ,yBAAA;EACA,qBAAA;AAHR;AAnEA;EAuE0B,yBAAA;AAD1B;AAtEA;EA0EQ,yBAAA;AADR;AAzEA;EA4EqC,yBAAA;AAArC;AA5EA;EA+EM,yBAAA;AAAN;AAIM;EACE,yBAAA;EACA,YAAA;AAFR;AAOE;EAAA;IAEI,mBAAA;EALJ;AACF;AASA;EAEI,aAAA;EACA,uBAAA;AARJ;AAKA;EAOI,qBAAA;EACA,mBAAA;EACA,qBAAA;AATJ;AAAA;EAaI,2BAAA;AAVJ","sourcesContent":["#partner-landing-screen {\n  #olist {\n    .partner-landing-header {\n      background-color: #0c29d0;\n      \n      .logo {\n        width: 9rem;\n      }\n      \n      @media(max-width: @md-screen) {\n        padding-top: .5rem;\n        padding-bottom: .5rem;\n      }\n    }\n    \n    .olist-title {\n       color: #0c29d0;\n     }\n     .olist-white-title {\n       color: #d2f9ed;\n     }\n\n    .steps-content {\n      margin-top: 1.25rem;\n    }\n    \n    .light {\n      color: black !important;\n      background-color: var(--primary-light-color) !important;\n      .ant-layout-content {\n        background-color: transparent !important;\n      }\n      h1, h2, h3 {\n        color: black;\n      }\n    }\n    \n    .soft {\n      color: black !important;\n      background-color: #e1eef1 !important;\n      .ant-layout-content {\n        background-color: transparent !important;\n      }      \n      h1, h2, h3 {\n        color: black;\n      }\n    }\n    \n    .dark {\n      color: white !important;\n      background-color: #0c29d0 !important;\n      .ant-layout-content {\n        background-color: transparent !important;\n      }\n      h1, h2, h3 {\n        color: white;\n      }\n    }\n \n    .ant-steps {\n      .ant-steps-item-active .ant-steps-icon {\n        color: #ffffff !important\n      }\n\n      .ant-steps-item-process .ant-steps-item-icon {\n        background-color: #0c29d0;\n        border-color: #0c29d0;\n      }\n      .ant-steps-item-finish .ant-steps-item-icon {\n        background-color: #0c29d0;\n        border-color: #0c29d0;\n        .ant-steps-icon { color: #ffffff !important }\n      }\n      .ant-steps-item::before {\n        background-color: #0c29d0;\n      }\n      .ant-steps-item-title::hover { background-color: #0c29d0; }\n    }\n    .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {\n      background-color: #0c29d0;\n    }\n    \n    .gyramais-btn {\n      &.gyramais-btn-olist{\n        background-color: #0c29d0;\n        color: white;\n      }\n    }\n  }\n\n  @media(max-width: @md-screen) {\n    .gyra-logo-partner {\n      margin-bottom: 1rem;\n    }\n  }\n}\n\n.codeAlreadyUsedModal{\n  .img-container{\n    display: flex;\n    justify-content: center;\n  }\n\n  .confirm-modal-image {\n    max-height: 10.813rem;\n    margin-top: .75rem;\n    margin-bottom: 1.5rem;\n  }\n\n  button{\n    margin-top: 1rem !important;\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
